import {HistoryBridge} from '../historyBridge';
import {createClassLogger, Logger} from '../../utils/Logging';

const logger: Logger = createClassLogger('HistoryBridge:Mock');

const historyMock: HistoryBridge = {
    pushUrlHistory: async (): Promise<void> => {
        logger.info('pushUrlHistory', 'MOCKED');
    },
    replaceUrlHistory: async (): Promise<void> => {
        logger.info('replaceUrlHistory', 'MOCKED');
    },
    refresh: async (): Promise<void> => {
        logger.info('refresh', 'MOCKED');
    }
};

export default historyMock;
